// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.manager[data-v-7a37859a] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    margin-top: 1em !important;\n    position: sticky;\n    top: 0;\n    margin-bottom: 10px !important;\n}\n.firm-dropdown-menu[data-v-7a37859a] {\n    margin-right: 2px !important;\n}\n", ""]);
// Exports
module.exports = exports;
